import { build } from "../../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/billing/v3/payroll",
		component: lazy(() => import("./EnterprisePayrollPage")),
	},
]);
